import { Dialog } from "construct-ui";
import moment from "moment";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import QuarterPickerComponent from "../../../components/date-picker/quarter-picker.component";
import YearPickerComponent from "../../../components/date-picker/year-picker.component";
import PivotTableComponent from "../../../components/pivot-table/pivot-table.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { DATE_TYPE_CODES, formats as FORMATS, REPORT_GRID_LAYOUT, KEYS_SEPARATOR, KEY_VALUE_SEPARATOR } from "../../../config/constants";
import loginModel from "../../../models/login.model";
import ReportModel from "../../../models/report/report-model.model";
import ViewBase from "../../view-base.view";
import { stringifyFilterParams } from '../utils.js'

export default function ReportViewerView() {
  ViewBase.call(this);
  let dataSourceCode;
  let filterParams = {};

  let childReportDetails;
  let reportHeight = 236;

  let lastGenerated;
  let lastGeneratedDetail;

  let params = {};
  // let customCellFormat;
  let isDetailView = false;
  let isDetailHtmlReportView = false;
  let reportHtmlData = null;

  const defaultTabs = [];

  const DEFAULT_DETAIL_ADDITIONAL_FILTER_PARAMS = Object.freeze({
    detailData: {},              // Column headers
    detailFilter: [],              // Row headers
  });

  const DEFAULT_FILTER_PARAMS = Object.freeze({
    period: null,           // Report period type
    mtdDay: '1',            // Day for MTD report (only applicable for MTD report)
    fromDate: moment().format(FORMATS.ISO_DATE_FORMAT),   // Period start date
    toDate: moment().format(FORMATS.ISO_DATE_FORMAT),     // Period end date
    parameters: null,       // Filters selected from `DynamicReportFilterComponent`
    xAxis: [],              // Column headers
    yAxis: [],              // Row headers
    zAxis: [],              // Data display
    xAxisOrderedCodes: [],  // Order of column header codes
    yAxisOrderedCodes: [],  // Order of row header codes
    zAxisOrderedCodes: [],  // Order of data display codes
    linkYAxis: [],  // Order of data display codes
    linkZAxis: [],  // Order of data display codes
    layout: REPORT_GRID_LAYOUT.CLASSIC,  // Order of data display codes
  });

  const isDayPeriod = () => {
    return filterParams.period === DATE_TYPE_CODES.DAY;
  }

  const isWeekPeriod = () => {
    return filterParams.period === DATE_TYPE_CODES.WEEK;
  }

  const isMonthPeriod = () => {
    return filterParams.period === DATE_TYPE_CODES.MONTH;
  }

  const isYearPeriod = () => {
    return filterParams.period === DATE_TYPE_CODES.YEAR;
  }

  const isQuarterPeriod = () => {
    return filterParams.period === DATE_TYPE_CODES.QUARTER;
  }

  const isMTDPeriod = () => {
    return filterParams.period === DATE_TYPE_CODES.MTD;
  }

  /**
   * Array of day range: 1 ~ 31
   */
  const DAY_OPTIONS = (() => {
    const days = [];
    for (let x = 1; x <= 31; x++) {
      days.push({ code: x.toString(), name: x.toString() });
    }
    return days;
  })()

  const getDefaultDateByPeriod = (period, num) => {
    switch (period) {
      case DATE_TYPE_CODES.MONTH:
        return moment().add(num, 'month').format(FORMATS.API_MONTH_FORMAT);

      case DATE_TYPE_CODES.MTD:
        return moment().add(num, 'month').format(FORMATS.API_MONTH_FORMAT);

      case DATE_TYPE_CODES.WEEK:
        return moment().add(num, 'week').format(FORMATS.API_WEEK_FORMAT);

      case DATE_TYPE_CODES.DAY:
        return moment().add(num, 'day').format(FORMATS.apiDateFormat);

      case DATE_TYPE_CODES.QUARTER:
        return moment().add(num * 3, 'month').format(FORMATS.API_QUARTER_FORMAT);

      case DATE_TYPE_CODES.YEAR:
        return moment().add(num, 'year').format(FORMATS.YEAR_FORMAT);

      default:
        return moment().format(FORMATS.apiDateFormat);
    }
  }

  const getMaxPeriod = () => {
    return 0;
  }

  const getMinPeriod = () => {
    switch (filterParams.period) {
      case "D": return -365;
      case "W": return -52;
      case "M": return -12;
      case "Q": return -4;
      case "Y": return -1;
      case "T": return -3;
      default: return 0;
    }
  }

  const setFilter = (prop, value) => {
    if (!prop || filterParams[prop] === value) return false;
    filterParams[prop] = value;
    return true;
  }

  const _getParams = () => {
    params = {
      countryCode: loginModel.credentials.country,
      dataSourceCode: dataSourceCode,
      periodCode: filterParams.period,
      fromDate: filterParams.fromDate + (isMTDPeriod() ? filterParams.mtdDay.padStart(2, '0') : ''),
      toDate: filterParams.toDate + (isMTDPeriod() ? filterParams.mtdDay.padStart(2, '0') : ''),
      parameters: stringifyFilterParams(filterParams.parameters),
      xAxis: filterParams.xAxisOrderedCodes,
      yAxis: filterParams.yAxisOrderedCodes,
      zAxis: filterParams.zAxisOrderedCodes,
      linkYAxis: filterParams.linkYAxis,
      linkZAxis: filterParams.linkZAxis,
      layout: filterParams.layout,
      // customCellFormat: customCellFormat,
      //for report details
      id: childReportDetails.detailData.code,
      filter: childReportDetails.detailFilter && Array.isArray(childReportDetails.detailFilter) ? stringifyFilterParams(childReportDetails.detailFilter.map((item) => ({ key: item.name, value: item.value }))) : '',
      // selectedLabel: childReportDetails.selectedValue,
    }
    return params;
  }

  const generateReport = (e) => {
    // Form validation
    if (!this.validateForm(e, '#report-generate-form.needs-validation')) {
      return false;
    } else {
      lastGenerated = new Date().toISOString();
    }
  }

  const populateFilter = (details) => {
    const _dateStart = details.period === "M" ? -3 : -4;
    const _dateEnd = -1 + (details.includeCurrent ? 1 : 0);

    dataSourceCode = details.dataSourceCode;
    filterParams.period = details.period;
    filterParams.fromDate = getDefaultDateByPeriod(details.period, _dateStart);
    filterParams.toDate = getDefaultDateByPeriod(details.period, _dateEnd);
    // filterParams.fromDate = isMTDPeriod(details.period) ? moment(details.fromDate).format(FORMATS.API_MONTH_FORMAT) : details.fromDate;
    // filterParams.toDate = isMTDPeriod(details.period) ? moment(details.toDate).format(FORMATS.API_MONTH_FORMAT) : details.toDate;
    // filterParams.mtdDay = isMTDPeriod(details.period) ? moment(details.fromDate).format('D') : '1';
    filterParams.parameters = details.filters;
    filterParams.xAxis = details.xAxis ? details.xAxis.split(KEYS_SEPARATOR).map(v => ({ code: v, name: v })) : [];
    filterParams.yAxis = details.yAxis ? details.yAxis.split(KEYS_SEPARATOR).map(v => ({ code: v, name: v })) : [];
    filterParams.zAxis = details.zAxis ? details.zAxis.split(KEYS_SEPARATOR).map(v => ({ code: v, name: v.split(KEY_VALUE_SEPARATOR).at(0) })) : [];
    filterParams.xAxisOrderedCodes = details.xAxis ? details.xAxis.split(KEYS_SEPARATOR) : [];
    filterParams.yAxisOrderedCodes = details.yAxis ? details.yAxis.split(KEYS_SEPARATOR) : [];
    filterParams.zAxisOrderedCodes = details.zAxis ? details.zAxis.split(KEYS_SEPARATOR) : [];
    filterParams.linkYAxis = details.linkYAxis ? details.linkYAxis.split(KEYS_SEPARATOR).map(v => ({ code: v.split(KEY_VALUE_SEPARATOR).at(1) ?? v, name: v.split(KEY_VALUE_SEPARATOR).at(0) })) : [];
    filterParams.linkZAxis = details.linkZAxis ? details.linkZAxis.split(KEYS_SEPARATOR).map(v => ({ code: v.split(KEY_VALUE_SEPARATOR).at(1) ?? v, name: v.split(KEY_VALUE_SEPARATOR).at(0) })) : [];
    filterParams.layout = details.layout;
  }

  const loadReportTemplate = (reportId, parametersFromUrl = null) => {
    this.showLoading();

    ReportModel.getMobileReportTemplate(reportId)
      .then((data) => {
        if (parametersFromUrl) {
          if (data.filters && Array.isArray(data.filters)) {
            data.filters.push(parametersFromUrl)
          }
        }
        populateFilter(data);
        // customCellFormat = data?.customCellFormat ?? undefined;
        //generate report
        lastGenerated = new Date().toISOString();
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  const getReportHtmlData = (_reportParameter) => {
    this.showLoading();
    ReportModel.getReportHtmlData(_reportParameter).then((result) => {
      reportHtmlData = result;
      isDetailHtmlReportView = true;
    }).catch((error) => {
      this.handleError(error);
    }).finally(() => {
      this.hideLoading();
    })
  }


  const initializeReportPage = () => {
    // Initialize data
    filterParams = structuredClone(DEFAULT_FILTER_PARAMS);
    childReportDetails = structuredClone(DEFAULT_DETAIL_ADDITIONAL_FILTER_PARAMS);
    lastGenerated = undefined;
    lastGeneratedDetail = undefined;
  }

  const isRange = (periodType) => {
    if (!periodType) return false;
    // return !!periodTypes.find(p => p.code.toLowerCase() === periodType.toLowerCase())?.isRange;
    return true;
  }

  const renderDateInputLabel = () => {
    if (filterParams.period) {
      if (filterParams.period === DATE_TYPE_CODES.MONTH
        || filterParams.period === DATE_TYPE_CODES.MTD) {
        return this.getText("LT00000326", "Month");
      }

      if (filterParams.period === DATE_TYPE_CODES.WEEK) {
        return this.getText("LT00000337", "Week");
      }

      if (filterParams.period === DATE_TYPE_CODES.DAY) {
        return this.getText("LT00000132", "Date");
      }

      if (filterParams.period === DATE_TYPE_CODES.QUARTER) {
        return this.getText("LT00001129", "Quarter");
      }

      if (filterParams.period === DATE_TYPE_CODES.YEAR) {
        return this.getText("LT00001128", "Year");
      }
    }

    return this.getText("LT00000968", "Range");
  }

  /**
   * Date Input Component for Day period type
   */
  const DateInputComponentForDay = () => {
    return {
      view: () => [
        m(DatePickerComponent, {
          id: 'range',
          class: 'form-control',
          isRange: isRange(filterParams.period),
          grid: 1,
          calendars: 1,
          date: isRange(filterParams.period)
            ? undefined
            : moment(filterParams.fromDate).format(FORMATS.dateFormat),
          dateStart: isRange(filterParams.period)
            ? filterParams.fromDate
              ? moment(filterParams.fromDate).format(FORMATS.dateFormat)
              : null
            : undefined,
          dateEnd: isRange(filterParams.period)
            ? filterParams.toDate
              ? moment(filterParams.toDate).format(FORMATS.dateFormat)
              : null
            : undefined,
          maxDate: moment().add(getMaxPeriod(), 'days').format(FORMATS.dateFormat),
          minDate: moment().add(getMinPeriod(), 'days').format(FORMATS.dateFormat),
          readonly: true,
          required: true,
          onselect: (e) => {
            if (isRange(filterParams.period)) {
              setFilter('fromDate', moment(e.detail.start).format(FORMATS.apiDateFormat));
              setFilter('toDate', moment(e.detail.end).format(FORMATS.apiDateFormat));
            } else {
              setFilter('fromDate', moment(e.detail.date).format(FORMATS.apiDateFormat));
              setFilter('toDate', moment(e.detail.date).format(FORMATS.apiDateFormat));
            }
          }
        }),
      ]
    }
  }

  /**
   * Date Input Component for Week period type
   */
  const DateInputComponentForWeek = () => {
    return {
      view: () => [
        m('.d-flex.gap-1',
          isRange(filterParams.period)
            ? [ // Week range
              m('.position-relative',
                m('input#range.form-control[name="fromDate"][type="week"][required]', {
                  style: "width: auto; padding-right: 2.25rem;",
                  min: moment().add(getMinPeriod(), 'weeks').format(FORMATS.WEEK_FORMAT),
                  max: filterParams.toDate
                    ? moment(filterParams.toDate, FORMATS.API_WEEK_FORMAT).format(FORMATS.WEEK_FORMAT)
                    : moment().add(getMaxPeriod(), 'weeks').format(FORMATS.WEEK_FORMAT),
                  value: filterParams.fromDate
                    ? moment(filterParams.fromDate, FORMATS.API_WEEK_FORMAT).format(FORMATS.WEEK_FORMAT)
                    : null,
                  onchange: (e) => {
                    let selectedDate = e.target.value
                      ? moment(e.target.value, FORMATS.WEEK_FORMAT).format(FORMATS.API_WEEK_FORMAT)
                      : null;
                    setFilter(e.target.name, selectedDate);
                  }
                }),
                m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
              ),
              m('.my-auto', '~'),
              m('.position-relative',
                m('input#range2.form-control[name="toDate"][type="week"][required]', {
                  style: "width: auto; padding-right: 2.25rem;",
                  min: filterParams.fromDate
                    ? moment(filterParams.fromDate, FORMATS.API_WEEK_FORMAT).format(FORMATS.WEEK_FORMAT)
                    : moment().add(getMinPeriod(), 'weeks').format(FORMATS.WEEK_FORMAT),
                  max: moment().add(getMaxPeriod(), 'weeks').format(FORMATS.WEEK_FORMAT),
                  value: filterParams.toDate ? moment(filterParams.toDate, FORMATS.API_WEEK_FORMAT).format(FORMATS.WEEK_FORMAT) : null,
                  onchange: (e) => {
                    let selectedDate = e.target.value ? moment(e.target.value, FORMATS.WEEK_FORMAT).format(FORMATS.API_WEEK_FORMAT) : null;
                    setFilter(e.target.name, selectedDate);
                  }
                }),
                m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
              ),
            ]
            : [ // Single week
              m('.position-relative',
                m('input#range.form-control[type="week"][required]', {
                  min: moment().add(getMinPeriod(), 'weeks').format(FORMATS.WEEK_FORMAT),
                  max: moment().add(getMaxPeriod(), 'weeks').format(FORMATS.WEEK_FORMAT),
                  value: filterParams.fromDate ? moment(filterParams.fromDate, FORMATS.API_WEEK_FORMAT).format(FORMATS.WEEK_FORMAT) : null,
                  onchange: (e) => {
                    let selectedDate = e.target.value ? moment(e.target.value, FORMATS.WEEK_FORMAT).format(FORMATS.API_WEEK_FORMAT) : null;
                    setFilter('fromDate', selectedDate);
                    setFilter('toDate', selectedDate);
                  }
                }),
                m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
              ),
            ],
        ),
      ]
    }
  }

  /**
   * Date Input Component for Month / MTD period type
   */
  const DateInputComponentForMonth = () => {
    return {
      view: () => [
        m('.d-flex.flex-wrap.gap-1.w-100',
          isRange(filterParams.period)
            ? [ // Month range
              m('.position-relative',
                m('input#range.form-control[name="fromDate"][type="month"][required]', {
                  style: "width: auto; padding-right: 1.25rem;",
                  min: moment().add(getMinPeriod(), 'months').format(FORMATS.MONTH_FORMAT),
                  max: filterParams.toDate
                    ? moment(filterParams.toDate, FORMATS.API_MONTH_FORMAT).format(FORMATS.MONTH_FORMAT)
                    : moment().add(getMaxPeriod(), 'months').format(FORMATS.MONTH_FORMAT),
                  value: filterParams.fromDate
                    ? moment(filterParams.fromDate, FORMATS.API_MONTH_FORMAT).format(FORMATS.MONTH_FORMAT)
                    : null,
                  onchange: (e) => {
                    let selectedDate = e.target.value
                      ? moment(e.target.value, FORMATS.MONTH_FORMAT).format(FORMATS.API_MONTH_FORMAT)
                      : null;
                    setFilter(e.target.name, selectedDate);
                  }
                }),
                m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
              ),
              m('.my-auto', '~'),
              m('.position-relative',
                m('input#range2.form-control[name="toDate"][type="month"][required]', {
                  style: "width: auto; padding-right: 1.25rem;",
                  min: filterParams.fromDate
                    ? moment(filterParams.fromDate, FORMATS.API_MONTH_FORMAT).format(FORMATS.MONTH_FORMAT)
                    : moment().add(getMinPeriod(), 'months').format(FORMATS.MONTH_FORMAT),
                  max: moment().add(getMaxPeriod(), 'months').format(FORMATS.MONTH_FORMAT),
                  value: filterParams.toDate
                    ? moment(filterParams.toDate, FORMATS.API_MONTH_FORMAT).format(FORMATS.MONTH_FORMAT)
                    : null,
                  onchange: (e) => {
                    let selectedDate = e.target.value
                      ? moment(e.target.value, FORMATS.MONTH_FORMAT).format(FORMATS.API_MONTH_FORMAT)
                      : null;
                    setFilter(e.target.name, selectedDate);
                  }
                }),
                m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
              ),
            ]
            : [ // Single month
              m('.position-relative',
                m('input#range.form-control[type="month"][required]', {
                  min: moment().add(getMinPeriod(), 'months').format(FORMATS.MONTH_FORMAT),
                  max: moment().add(getMaxPeriod(), 'months').format(FORMATS.MONTH_FORMAT),
                  value: filterParams.fromDate ? moment(filterParams.fromDate, FORMATS.API_MONTH_FORMAT).format(FORMATS.MONTH_FORMAT) : null,
                  onchange: (e) => {
                    let selectedDate = e.target.value ? moment(e.target.value, FORMATS.MONTH_FORMAT).format(FORMATS.API_MONTH_FORMAT) : null;
                    setFilter('fromDate', selectedDate);
                    setFilter('toDate', selectedDate);
                  }
                }),
                m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
              ),
            ]
        ),
      ]
    }
  }

  /**
   * Date Input Component for Quarter period type
   */
  const DateInputComponentForQuarter = () => {
    return {
      view: () => [
        m('.d-flex.gap-1',
          isRange(filterParams.period)
            ? [ // Quarter range
              m(QuarterPickerComponent, {
                id: 'range',
                max: moment().add(getMaxPeriod(), 'quarters').format(FORMATS.API_QUARTER_FORMAT),
                min: moment().add(getMinPeriod(), 'quarters').format(FORMATS.API_QUARTER_FORMAT),
                required: true,
                selectedItem: filterParams.fromDate ? filterParams.fromDate : null,
                onSelect: (item) => {
                  setFilter('fromDate', item ? item : null);
                }
              }),
              m('.px-2.my-auto', '~'),
              m(QuarterPickerComponent, {
                id: 'range2',
                max: moment().add(getMaxPeriod(), 'quarters').format(FORMATS.API_QUARTER_FORMAT),
                min: moment().add(getMinPeriod(), 'quarters').format(FORMATS.API_QUARTER_FORMAT),
                required: true,
                selectedItem: filterParams.toDate ? filterParams.toDate : null,
                onSelect: (item) => {
                  setFilter('toDate', item ? item : null);
                }
              }),
            ]
            : [ // Single quarter
              m(QuarterPickerComponent, {
                id: 'range',
                max: moment().add(getMaxPeriod(), 'quarters').format(FORMATS.API_QUARTER_FORMAT),
                min: moment().add(getMinPeriod(), 'quarters').format(FORMATS.API_QUARTER_FORMAT),
                required: true,
                selectedItem: filterParams.fromDate ? filterParams.fromDate : null,
                onSelect: (item) => {
                  setFilter('fromDate', item ? item : null);
                  setFilter('toDate', item ? item : null);
                }
              }),
            ],
        ),
      ]
    }
  }

  /**
   * Date Input Component for Year period type
   */
  const DateInputComponentForYear = () => {
    return {
      view: () => [
        m('.d-flex.gap-1',
          isRange(filterParams.period)
            ? [ // Year range
              m(YearPickerComponent, {
                id: 'range',
                max: moment().add(getMaxPeriod(), 'years').format(FORMATS.YEAR_FORMAT),
                min: moment().add(getMinPeriod(), 'years').format(FORMATS.YEAR_FORMAT),
                required: true,
                selectedItem: filterParams.fromDate ? filterParams.fromDate : null,
                onSelect: (item) => {
                  setFilter('fromDate', item ? item : null);
                }
              }),
              m('.px-2.my-auto', '~'),
              m(YearPickerComponent, {
                id: 'range2',
                max: moment().add(getMaxPeriod(), 'years').format(FORMATS.YEAR_FORMAT),
                min: moment().add(getMinPeriod(), 'years').format(FORMATS.YEAR_FORMAT),
                required: true,
                selectedItem: filterParams.toDate ? filterParams.toDate : null,
                onSelect: (item) => {
                  setFilter('toDate', item ? item : null);
                }
              }),
            ]
            : [ // Single year
              m(YearPickerComponent, {
                id: 'range',
                max: moment().add(getMaxPeriod(), 'years').format(FORMATS.YEAR_FORMAT),
                min: moment().add(getMinPeriod(), 'years').format(FORMATS.YEAR_FORMAT),
                required: true,
                selectedItem: filterParams.fromDate ? filterParams.fromDate : null,
                onSelect: (item) => {
                  setFilter('fromDate', item ? item : null);
                  setFilter('toDate', item ? item : null);
                }
              }),
            ],
        ),
      ]
    }
  }

  /**
   * Report Period Section
   */
  const SectionReportPeriod = () => {
    return {
      view: () => [
        m('.d-flex.gap-4',
          filterParams.period &&
          m('.d-flex.flex-column',
            m('label.form-label.mandatory[for=range]',
              renderDateInputLabel(),
            ),
            isDayPeriod() &&
            m(DateInputComponentForDay),
            isWeekPeriod() &&
            m(DateInputComponentForWeek),
            (isMonthPeriod() || isMTDPeriod()) &&
            m(DateInputComponentForMonth),
            isYearPeriod() &&
            m(DateInputComponentForYear),
            isQuarterPeriod() &&
            m(DateInputComponentForQuarter),
          ),
          isMTDPeriod() &&
          m('.d-flex.flex-column.flex-shrink-0',
            m('label.form-label[for=day]', this.getText('LT00001021', 'Day')),
            m(SingleSelectComponent, {
              id: 'day',
              keyOnly: true,
              items: DAY_OPTIONS,
              selectedItem: filterParams.mtdDay,
              onSelect: (selected) => {
                filterParams.mtdDay = selected;
              }
            }),
          ),
        )
      ]
    }
  }

  const _onCellClick = (linkElementName, childReportDetailsData = {
    detailData: {},  // Column headers
    detailFilter: [], // Row headers
  }) => {
    if (linkElementName && linkElementName.code) {
      ReportModel.getMobileReportTemplate(linkElementName.code).then((data) => {
        //generate report
        childReportDetails = childReportDetailsData;
        if (data.layout === REPORT_GRID_LAYOUT.HTML) {
          const _reportParameter = {
            dataSourceCode: params.dataSourceCode, // "McsProProduct",
            periodCode: params.periodCode,         // "M",
            fromDate: params.fromDate,             // "202201",
            toDate: params.toDate,                 // "202203",
            xAxis: params.xAxis?.join('^^') || '', // "Year^^Month",
            yAxis: params.yAxis?.join('^^') || '', // "BU^^Div",
            zAxis: params.zAxis?.join('^^') || '', // "SO Qty:=SELLOUT_QTY^^SO Amt:=SELLOUT_AMT"
            parameters: params.parameters || '',
            id: childReportDetailsData.detailData?.code,
            filter: childReportDetailsData.detailFilter && Array.isArray(childReportDetailsData.detailFilter) ? stringifyFilterParams(childReportDetailsData.detailFilter.map((item) => ({ key: item.name, value: item.value }))) : '',
          }
          getReportHtmlData(_reportParameter)
        } else {
          showChildReportDialog();
        }  
      }).catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        m.redraw()
      });
    }

  }

  const showChildReportDialog = () => {
    lastGeneratedDetail = new Date().toISOString();
    isDetailView = true;
    // m.redraw();
  }

  const closeChildReportDialog = () => {
    isDetailView = false;
  }

  const closeChildHtmlReportDialog = () => {
    isDetailHtmlReportView = false;
  }

  const handleCollapse = (e) => {
    if (e.target?.classList?.contains('collapsed')) {
      reportHeight = 52 + 16; // 52: element height; 16: margin height
    } else {
      reportHeight = 220 + 16; // 220: element height; 16: margin height
    }
  }

  const setTokenAndInitialize = (token, refreshToken, reportGuid) => {
    if (token != '') {
      // from public
      
      if (token.includes('|'))
      {
        var arrToken = token.split('|');
        this.showLoading();

        ReportModel.getDecryptedRSA(arrToken.pop())
          .then((data) => {
            var nToken = arrToken.shift() + '.' + data;
            loginModel.setToken(nToken, refreshToken);
            initializeReportPage();
            loadReportTemplate(reportGuid);
          })
          .catch((error) => {
            this.handleError(error);
          })
          .finally(() => {
            this.hideLoading();
          })
      } else {
        initializeReportPage();
        loadReportTemplate(reportGuid);
      }
    }
  }

  return {
    oninit: ({ attrs: { reportGuid } }) => {
      const _token = m.route.param("t") ?? '';
      const _refreshToken = m.route.param("r") ?? '';
      setTokenAndInitialize(decodeURIComponent(_token), _refreshToken, reportGuid);      
    },

    view: () => {
      return [
        m('.h-100.w-100',
          // Filter section
          m('#report-filter-section.d-flex.flex-column.align-items-end.gap-2.mb-3',
            m(`.accordion#report-accordion.w-100`,
              m(".accordion-item",
                m(`h2.accordion-header#report-data-type-heading`,
                  m(`button.accordion-button[type=button][data-bs-toggle=collapse][data-bs-target=#report-data-type-collapse][aria-expanded=true][aria-controls=report-data-type-collapse]`,
                    {
                      onclick: handleCollapse
                    },
                    m("span", this.getText("LT00000967", "Report Period"))
                  )
                ),
                m(`.accordion-collapse.collapse.show#report-data-type-collapse[aria-labelledby=report-data-type-heading][data-bs-parent=#report-accordion]`,
                  m(".accordion-body.p-3",
                    m('form#report-generate-form.needs-validation[novalidate]', {
                      onsubmit: generateReport
                    },
                      m('.row.g-4',
                        m('.col-12',
                          m(SectionReportPeriod),
                        ),
                      ),

                      m('.row.g-3.mt-1',
                        // Generate buttons
                        m('.col-12.d-flex.justify-content-end.gap-2',
                          m('button.btn.btn-primary[type=submit]',
                            this.getText("LT00001003", "Generate")
                          ),
                        ),
                      ),
                    ),
                  )
                )
              ),
            )
          ),

          // Pivot table component
          m(PivotTableComponent, {
            id: 'mobile-report-pivot',
            lastGenerated: lastGenerated,
            defaultTabs: defaultTabs,
            reportHeight: reportHeight,
            reportParams: _getParams,
            onCellClick: _onCellClick,
          }),
        ),
        isDetailHtmlReportView && m(Dialog, {
          title: this.getText('LT00000964', 'Report Detail'),
          isOpen: isDetailHtmlReportView,
          onClose: () => { closeChildHtmlReportDialog() },
          transitionDuration: 200,
          closeOnOutsideClick: false,
          "class": "width-100, cui-dialog-msgbox, cui-dialog-msgbox-mobile",
          content: [
            m('div', m.trust(reportHtmlData))
          ], // content - end
        }),
        isDetailView && m(Dialog, {
          title: this.getText('LT00000964', 'Report Detail'),
          isOpen: isDetailView,
          onClose: () => { closeChildReportDialog() },
          onOpened: () => {
            if (lastGeneratedDetail) {
              m.redraw();
            }
          },
          transitionDuration: 200,
          closeOnOutsideClick: false,
          "class": "width-100, cui-dialog-msgbox, cui-dialog-msgbox-mobile",
          content: [
            // m('.container.pt-2.pb-4',
            //   m('pre', JSON.stringify(_getParams(), undefined, 2)),
            // ),
            m(PivotTableComponent, {
              id: 'mobile-report-pivot-detail',
              lastGenerated: lastGeneratedDetail,
              defaultTabs: defaultTabs,
              reportHeight: 130,
              reportParams: _getParams,
            }),
          ], // content - end
        }),
        this.getBaseViews()
      ]
    }
  }
}
